
const actionHistoryFields = vm => [
  {
    key: 'eventDate',
    sortable: false,
    label: vm.$t('fields.engineering.commutator-maintenance.event-date'),
    class: 'actions-history-section__cell-event-date',
  },
  {
    key: 'identifiedByIed',
    sortable: false,
    label: vm.$t('fields.engineering.commutator-maintenance.identified-by-sensor'),
    class: 'truncate actions-history-section__cell-identified-by-ied',
  },
  {
    key: 'informedMaintenance',
    sortable: false,
    label: vm.$t('fields.engineering.commutator-maintenance.informed-maintenance'),
    class: 'actions-history-section__cell-informed-maintenance',
  },
  {
    key: 'inclusionUser',
    sortable: false,
    label: vm.$t('fields.engineering.commutator-maintenance.inclusion-user'),
    class: 'actions-history-section__cell-inclusion-user',
  },
  {
    key: 'maintenanceDate',
    sortable: false,
    label: vm.$t('fields.engineering.commutator-maintenance.maintenance-date'),
    class: 'actions-history-section__cell-maintenance-date',
  },
  {
    key: 'duration',
    sortable: false,
    label: vm.$t('fields.engineering.commutator-maintenance.duration'),
    class: 'actions-history-section__cell-duration',
  },
  {
    key: 'actions',
    sortable: false,
    label: '',
    class: 'actions-history-section__cell-actions',
  },
];

export default actionHistoryFields;
